import type { PortalNavItem } from '@/types';
import { QuickLinks } from '@/components/quicklinks';
import styles from './QuickLinksSection.module.css';

type QuickLinksSectionProps = {
  quickLinks: PortalNavItem['quickLinks'];
  activeTab: string | null;
  onTabChange: (tabId: string) => void;
};

export function QuickLinksSection({ quickLinks, activeTab, onTabChange }: QuickLinksSectionProps) {
  return (
    <div className={styles.wrapper}>
      <QuickLinks
        quickLinks={quickLinks}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
    </div>
  );
}
